import React, { memo } from 'react';

const UploadItemSkeleton = () => <div className="importFileItem tmp" />;

export default memo(UploadItemSkeleton);
